import { customersConstants } from "../../actions/customers/index";

import { combineReducers } from "redux";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

function customersList(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case customersConstants.GET_CUSTOMERS_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case customersConstants.GET_CUSTOMERS_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.list,
      accountantUuidSelected: payload.accountantUuidSelected
    };
  case customersConstants.GET_CUSTOMERS_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function dbxActivate(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case customersConstants.GET_CUSTOMERS_ACTIVATE_DBX_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case customersConstants.GET_CUSTOMERS_ACTIVATE_DBX_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case customersConstants.GET_CUSTOMERS_ACTIVATE_DBX_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}
export const customers = combineReducers({
  customersList,
  dbxActivate
});

export default customers;
